import { createContext } from 'react'

export const PaymentTypeContext = createContext(null)
